import { FETCH_COLLECTION_QUERY } from 'src/services/GraphQL/Queries/CollectionQuery';
import { GQL_QUERIES } from 'src/utils/analytics/newrelic/ErrorTracker';

import { SimilarContent } from '../../GraphQL/Queries/types';
import { graphQlRequest } from '../../GraphQL/RequestHandler';

export const generateFetchCollectionQueryParams = (
  collectionId: string,
  country: string,
  translation: string,
  languages = ''
) => {
  return {
    id: collectionId,
    filter: {
      page: 1,
      limit: 25,
      itemLimit: 25,
      country,
      translation,
      languages
    }
  };
};

export const fetchCollection = async (
  collectionId: string,
  country: string,
  translation = 'en',
  languages = ''
): Promise<SimilarContent> => {
  try {
    const response: any = await graphQlRequest(
      FETCH_COLLECTION_QUERY,
      generateFetchCollectionQueryParams(
        collectionId,
        country,
        translation,
        languages
      ),
      GQL_QUERIES.FETCH_COLLECTION_QUERY
    );
    return response?.collection || {};
  } catch (error) {
    console.error('Error while fetching latest movies: ', error);
    return {};
  }
};
